import { useEffect, useState } from "react";
import { useLang } from "../i18n/LangContext";
import { useAuth } from "../contexts/AuthContext";
import { api } from "../api/client";
import { PageHeader, EmptyState } from "../components/Shared";
import { DayJourney } from "../components/education/DayJourney";
import { L } from "../components/education/lib";
import { JourneyEditor } from "../components/education/JourneyEditor";
import { StreakBadge } from "../components/StreakBadge";
import { Button } from "../components/ui/button";

const tabClass = (active) =>
  active
    ? "h-10 bg-[#FF3B30] hover:bg-[#E02E24] text-white"
    : "h-10 border-white/15 bg-transparent text-slate-200 hover:bg-white/5 hover:text-white";

export default function Education() {
  const { t, lang } = useLang();
  const { user } = useAuth();
  const canEdit = user?.permissions?.includes("education.edit");
  const isCoach = user?.role === "COACH";
  const [journeys, setJourneys] = useState(null);
  const [tab, setTab] = useState(isCoach ? "coach" : "learn");

  useEffect(() => {
    api.get("/education/journeys/me").then(({ data }) => setJourneys(data.data)).catch(() => setJourneys([]));
  }, []);

  const fatLoss = (journeys || []).filter((j) => j.journey.journey_type === "FAT_LOSS");
  const coachJourneys = (journeys || []).filter((j) => j.journey.journey_type === "COACH_QUALIFICATION");
  const shown = tab === "coach" ? coachJourneys : fatLoss;

  const tabs = [
    ...(isCoach || canEdit ? [["coach", t("edu.coachTab")]] : []),
    ["learn", isCoach || canEdit ? t("edu.memberTab") : t("edu.learnerView")],
    ...(canEdit ? [["cms", t("edu.cms")]] : []),
  ];

  return (
    <div data-testid="education-page" className="space-y-8">
      <PageHeader eyebrow={t("education.eyebrow")} title={t("edu.title")} subtitle={t("edu.subtitle")}>
        {tabs.length > 1 && (
          <div className="flex flex-wrap gap-2">
            {tabs.map(([key, label]) => (
              <Button key={key} data-testid={`education-tab-${key}`} variant={tab === key ? "default" : "outline"}
                onClick={() => setTab(key)} className={tabClass(tab === key)}>
                {label}
              </Button>
            ))}
          </div>
        )}
      </PageHeader>

      {tab === "cms" && canEdit ? (
        <JourneyEditor />
      ) : journeys === null ? (
        <p className="text-slate-400">{t("common.loading")}</p>
      ) : shown.length === 0 ? (
        <EmptyState testId="education-empty" text={tab === "coach" ? t("edu.noCoachJourney") : t("edu.noJourney")} />
      ) : (
        <>
          {!canEdit && tab !== "coach" && <StreakBadge />}
          {tab === "coach" && <p className="text-xs text-slate-500">{t("edu.coachTabHint")}</p>}
          {shown.map((j) => (
            <div key={j.journey.journey_id} className="space-y-3">
              <h2 className="text-base md:text-lg font-semibold text-white">{L(j.journey.name, lang)}</h2>
              <DayJourney journeyId={j.journey.journey_id} />
            </div>
          ))}
        </>
      )}
    </div>
  );
}
